import { validateTextWithHypen, changeStartEndStringTimeZone, injectSeparatorTimeString, currency, formatBankAccount, formatBusinessNumber, numberToFormatted, formatPercent, percentSignSuffix, formatDate, } from '@/utils';
import { surchargeType, weekOptionList, } from '@/constants';
import goodsPayRestrictTypeCode from '@/constants/goodsPayRestrictType';
import adjustmentTypeCode from '@/constants/storeManagement/adjustmentType';
import goodsPayTypeCode from '@/constants/goodsPayType';
import { deliveryPayFlagOptionList, deliveryPayFlagDetailList, storeStatusOptionList, } from '@/constants/storeManagement';
import { isMonthlyChargeUnAcceptOptionList } from '@/constants/storeManagement/editDetailOptionList';
import { i18n } from '@/locales';
import AddressFormVM from '@/view-model/AddressFormVM';
import { fulfillmentStatus } from '@/constants/operationSetting/operationSettingOptionList';
import HubDetailVM from '@/view-model/hub/HubDetailVM';
import dateFormatType from '@/constants/dateFormatType';
import { fulfillmentState, timeZoneCode, vanCodeEnum, } from '@/constants/global';
import { distanceProductCodeObj } from '@/constants/distanceProductCode';
import { formatPhoneNumber } from '@/utils/regularExpression';
export default class Store {
    _name;
    _code;
    // type: string;
    _addChargeApplyYn;
    _addDeliveryCharge;
    _addDeliveryChargeRate;
    _addCookingTime;
    _deliveryWorkYn;
    _useYn;
    _hubDTO;
    _restDays;
    _workingTime;
    _phone;
    _ceoName;
    _ceoPhone;
    _latitude;
    _longitude;
    _addressSiDo;
    _addressSiGunGu;
    _addressDong;
    _addressLi;
    _addressJibun;
    _addressRoad;
    _addressBuildingNumber;
    _addressBuildingName;
    _addressDetail;
    _vatRate;
    _deliveryPayFlag;
    _endDeliveryCount;
    _monthDeliveryCount;
    _deliveryManagementFeePerOrder;
    _deliveryManagementFeeRatePerOrder;
    _deliveryFeeMonthly;
    _deliveryFeeMonthlyDay;
    _depositBaromoney;
    _baromoney;
    _createdAt;
    _masterId;
    _addressMemo;
    _memo;
    _safePhone;
    _fax;
    _mainVanTypeCode;
    _mainVanTerminalId;
    _withdrawalBankAccount;
    _withdrawalBankOwner;
    _withdrawalBankCode;
    _virtualBankAccount;
    _virtualBankCode;
    _bankTypeCode;
    _businessName;
    _businessNumber;
    _ceoEmail;
    _businessCondition;
    _businessType;
    _deliveryFeePerOrder;
    _deliveryFeeRatePerOrder;
    _hubDeliveryPrePaymentFee;
    _hubDeliveryPrePaymentFeeRate;
    _distanceProduct;
    _deliveryPayType;
    _goodsPayType;
    _options;
    _isSendBaromoneyRequired;
    _cookingTime;
    _dayDeliveryCount;
    _deliveryCancelTime;
    _orderLimitBaromoney;
    _addChargeUseYn;
    _workerFeePerStoreGroupDTO;
    _vatRateMonthly;
    _insufficientBaromoneyUnAcceptYn;
    _isDeliveryChargeNonSettingUnAccept;
    _isMonthlyChargeUnAccept;
    _ceoResidentRegistrationNumber;
    _goodsPriceSurchargeInfoDTOList;
    constructor({ code, name, addChargeApplyYn, addDeliveryCharge, addDeliveryChargeRate, addCookingTime, deliveryWorkYn, useYn, hubDTO, restDays, workingTime, phone, ceoName, ceoPhone, latitude, longitude, addressSiDo, addressSiGunGu, addressDong, addressLi, addressJibun, addressRoad, addressBuildingNumber, addressBuildingName, addressDetail, vatRate, deliveryPayFlag, endDeliveryCount, monthDeliveryCount, deliveryManagementFeePerOrder, deliveryManagementFeeRatePerOrder, deliveryFeeMonthly, deliveryFeeMonthlyDay, depositBaromoney, baromoney, createdAt, masterId, addressMemo, memo, safePhone, fax, mainVanTypeCode, mainVanTerminalId, withdrawalBankAccount, withdrawalBankOwner, withdrawalBankCode, virtualBankAccount, virtualBankCode, bankTypeCode, businessName, businessNumber, ceoEmail, businessCondition, businessType, deliveryFeePerOrder, deliveryFeeRatePerOrder, hubDeliveryPrePaymentFee, hubDeliveryPrePaymentFeeRate, distanceProduct, deliveryPayType, goodsPayType, options, isSendBaromoneyRequired, cookingTime, dayDeliveryCount, deliveryCancelTime, orderLimitBaromoney, addChargeUseYn, workerFeePerStoreGroupDTO, vatRateMonthly, insufficientBaromoneyUnAcceptYn, isDeliveryChargeNonSettingUnAccept, isMonthlyChargeUnAccept, ceoResidentRegistrationNumber, goodsPriceSurchargeInfoDTOList, }) {
        this._code = code;
        this._name = name;
        this._addChargeApplyYn = addChargeApplyYn === 'Y';
        this._addDeliveryCharge = addDeliveryCharge;
        this._addDeliveryChargeRate = addDeliveryChargeRate;
        this._addCookingTime = addCookingTime;
        this._deliveryWorkYn = deliveryWorkYn;
        this._useYn = useYn;
        this._restDays = restDays;
        this._workingTime = workingTime;
        this._phone = phone;
        this._ceoName = ceoName;
        this._ceoPhone = ceoPhone;
        this._latitude = latitude;
        this._longitude = longitude;
        this._addressSiDo = addressSiDo;
        this._addressSiGunGu = addressSiGunGu;
        this._addressDong = addressDong;
        this._addressLi = addressLi;
        this._addressJibun = addressJibun;
        this._addressRoad = addressRoad;
        this._addressBuildingNumber = addressBuildingNumber;
        this._addressBuildingName = addressBuildingName;
        this._addressDetail = addressDetail;
        this._vatRate = vatRate;
        this._deliveryPayFlag = deliveryPayFlag;
        this._endDeliveryCount = endDeliveryCount;
        this._monthDeliveryCount = monthDeliveryCount;
        this._deliveryManagementFeePerOrder = deliveryManagementFeePerOrder;
        this._deliveryManagementFeeRatePerOrder = deliveryManagementFeeRatePerOrder;
        this._deliveryFeeMonthly = deliveryFeeMonthly;
        this._deliveryFeeMonthlyDay = deliveryFeeMonthlyDay;
        this._deliveryManagementFeePerOrder = deliveryManagementFeePerOrder;
        this._endDeliveryCount = endDeliveryCount;
        this._depositBaromoney = depositBaromoney;
        this._baromoney = baromoney;
        this._createdAt = createdAt;
        this._hubDTO = new HubDetailVM(hubDTO);
        this._masterId = masterId;
        this._addressMemo = addressMemo;
        this._memo = memo;
        this._safePhone = safePhone;
        this._fax = fax;
        this._mainVanTypeCode = mainVanTypeCode;
        this._mainVanTerminalId = mainVanTerminalId;
        this._withdrawalBankAccount = withdrawalBankAccount;
        this._withdrawalBankOwner = withdrawalBankOwner;
        this._withdrawalBankCode = withdrawalBankCode;
        this._virtualBankAccount = virtualBankAccount;
        this._virtualBankCode = virtualBankCode;
        this._bankTypeCode = bankTypeCode;
        this._businessName = businessName;
        this._businessNumber = businessNumber;
        this._ceoEmail = ceoEmail;
        this._businessCondition = businessCondition;
        this._businessType = businessType;
        this._deliveryFeePerOrder = deliveryFeePerOrder;
        this._deliveryFeeRatePerOrder = deliveryFeeRatePerOrder;
        this._hubDeliveryPrePaymentFee = hubDeliveryPrePaymentFee;
        this._hubDeliveryPrePaymentFeeRate = hubDeliveryPrePaymentFeeRate;
        this._distanceProduct = distanceProduct;
        this._deliveryPayType = deliveryPayType;
        this._goodsPayType = goodsPayType;
        this._options = options;
        this._isSendBaromoneyRequired = isSendBaromoneyRequired;
        this._cookingTime = cookingTime;
        this._dayDeliveryCount = dayDeliveryCount;
        this._deliveryCancelTime = deliveryCancelTime;
        this._orderLimitBaromoney = orderLimitBaromoney;
        this._addChargeUseYn = addChargeUseYn;
        this._workerFeePerStoreGroupDTO = workerFeePerStoreGroupDTO;
        this._vatRateMonthly = vatRateMonthly;
        this._insufficientBaromoneyUnAcceptYn = insufficientBaromoneyUnAcceptYn;
        this._isDeliveryChargeNonSettingUnAccept = isDeliveryChargeNonSettingUnAccept;
        this._isMonthlyChargeUnAccept = isMonthlyChargeUnAccept;
        this._ceoResidentRegistrationNumber = ceoResidentRegistrationNumber;
        this._goodsPriceSurchargeInfoDTOList = goodsPriceSurchargeInfoDTOList;
    }
    get storeId() {
        return this.id;
    }
    get hub() {
        return this._hubDTO;
    }
    // id, code 둘다 쓰이는 중
    get id() {
        return this._code;
    }
    get code() {
        return this._code;
    }
    // 스토어 이름
    get name() {
        return this._name;
    }
    get addCookingTime() {
        return this._addCookingTime;
    }
    set addCookingTime(value) {
        this._addCookingTime = value;
    }
    // 설정 할증
    get addChargeApplyYn() {
        return this._addChargeApplyYn;
    }
    set addChargeApplyYn(value) {
        this._addChargeApplyYn = value;
    }
    // TODO: 설정 할증 문자열 (legacy) 추후 삭제
    get addChargeApplyYnToText() {
        const lc = 'views.operation_setting.';
        return this._addChargeApplyYn
            ? i18n.t(`${lc}charge_apply`)
            : i18n.t(`${lc}charge_clear`);
    }
    // 설정 할증 문자열 (운행설정 리뉴얼에 사용 + hub쪽과 네이밍 통일)
    get formattedAddChargeApplyYn() {
        const lc = 'views.operation_setting.';
        return this._addChargeApplyYn
            ? i18n.t(`${lc}charge_apply`)
            : i18n.t(`${lc}charge_clear`);
    }
    // 추가 할증 정액
    get addDeliveryCharge() {
        return this._addDeliveryCharge;
    }
    set addDeliveryCharge(value) {
        this._addDeliveryCharge = value;
    }
    // 추가 할증 (정률)
    get addDeliveryChargeRate() {
        return this._addDeliveryChargeRate;
    }
    set addDeliveryChargeRate(value) {
        this._addDeliveryChargeRate = value;
    }
    get deliveryWorkYn() {
        return this._deliveryWorkYn;
    }
    set deliveryWorkYn(value) {
        this._deliveryWorkYn = value;
    }
    // 추가 할증 정액 + 정률 (운행설정)
    get formattedAddDeliveryChargeAndRate() {
        const lc = 'views.operation_setting.';
        return [
            this.addDeliveryCharge,
            this.addDeliveryChargeRate,
        ].reduce((acc, it, index) => {
            if (it <= 0) {
                return acc;
            }
            if (index === 0) {
                acc.push(currency(it));
            }
            if (index === 1) {
                acc.push(i18n.t('unit.percent_suffix', {
                    number: it,
                }));
            }
            return acc;
        }, []).join(' + ') || i18n.t(`${lc}none_delivery_charge`);
    }
    // 수행상황
    get getFulfillmentState() {
        if (this.deliveryWorkYn !== 'Y') {
            return fulfillmentState.STOP;
        }
        if (this.addCookingTime > 0) {
            return fulfillmentState.DELAY;
        }
        return fulfillmentState.GOOD;
    }
    // 수행상황 (운행설정 리뉴얼)
    get getFulfillmentStatus() {
        if (this.deliveryWorkYn !== 'Y') {
            return fulfillmentStatus.STOP;
        }
        if (this.addCookingTime > 0) {
            return fulfillmentStatus.DELAY;
        }
        return fulfillmentStatus.GOOD;
    }
    // 수행상황 한글 locale
    get getFulfillmentStateToText() {
        const lc = 'views.operation_setting_dialog.fulfillment_state_';
        switch (this.getFulfillmentState) {
            case fulfillmentState.GOOD: return i18n.t(`${lc}good`);
            case fulfillmentState.DELAY: return i18n.t(`${lc}delay`, [
                this.addCookingTime,
            ]);
            case fulfillmentState.STOP: return i18n.t(`${lc}stop`);
            default: return '-';
        }
    }
    /**
     * 추가할증 여부
     * @returns {boolean}
     */
    get isAddDeliveryCharge() {
        return !!(this.addDeliveryChargeRate || this.addDeliveryCharge);
    }
    // 상점 사용여부
    get useYn() {
        return this._useYn;
    }
    get formattedUseYn() {
        const formatted = storeStatusOptionList.find((data) => data.value === this._useYn);
        return formatted?.text;
    }
    get withdrawalBankCode() {
        return this._withdrawalBankCode;
    }
    set withdrawalBankCode(value) {
        this._withdrawalBankCode = value;
    }
    get withdrawalBankAccount() {
        return this._withdrawalBankAccount;
    }
    set withdrawalBankAccount(value) {
        this._withdrawalBankAccount = value;
    }
    get withdrawalBankOwner() {
        return this._withdrawalBankOwner;
    }
    set withdrawalBankOwner(value) {
        this._withdrawalBankOwner = value;
    }
    get virtualBankCode() {
        return this._virtualBankCode;
    }
    get bankTypeCode() {
        return this._bankTypeCode;
    }
    get virtualBankAccount() {
        return this._virtualBankAccount;
    }
    get businessNumber() {
        return this._businessNumber;
    }
    get deliveryFeePerOrder() {
        return this._deliveryFeePerOrder;
    }
    get deliveryFeeRatePerOrder() {
        return this._deliveryFeeRatePerOrder;
    }
    get validatedHubName() {
        return validateTextWithHypen(this._hubDTO.name);
    }
    get validatedStoreName() {
        return validateTextWithHypen(this._name);
    }
    get restDays() {
        return this._restDays;
    }
    get validatedRestDays() {
        const shortenRestDaysOptionList = weekOptionList('shorten');
        const formattedRestDaysList = this.restDays
            .map((day) => shortenRestDaysOptionList[day].text);
        const lc = 'views.store_management.';
        if (formattedRestDaysList.length === 7) {
            return i18n.t(`${lc}seven_days_a_week`);
        }
        const isNotIncludeWeekendDay = this.restDays
            .every((day) => day !== shortenRestDaysOptionList.SATURDAY.value
            && day !== shortenRestDaysOptionList.SUNDAY.value);
        if (formattedRestDaysList.length === 5 && isNotIncludeWeekendDay) {
            return i18n.t(`${lc}weekday`);
        }
        if (formattedRestDaysList.length === 2 && !isNotIncludeWeekendDay) {
            return i18n.t(`${lc}weekend`);
        }
        return validateTextWithHypen(formattedRestDaysList.join(', '));
    }
    get workingTime() {
        return this._workingTime;
    }
    get formattedWorkingTime() {
        const krTimeString = changeStartEndStringTimeZone(this._workingTime, timeZoneCode.KR);
        return injectSeparatorTimeString(krTimeString);
    }
    get formattedPhone() {
        return validateTextWithHypen(formatPhoneNumber(this._phone));
    }
    get ceoName() {
        return this._ceoName;
    }
    get validatedCeoName() {
        return validateTextWithHypen(this.ceoName);
    }
    get ceoPhone() {
        return this._ceoPhone;
    }
    get formattedCeoPhone() {
        return validateTextWithHypen(formatPhoneNumber(this._ceoPhone));
    }
    get latitude() {
        return this._latitude;
    }
    get longitude() {
        return this._longitude;
    }
    get addressSiDo() {
        return this._addressSiDo;
    }
    get addressSiGunGu() {
        return this._addressSiGunGu;
    }
    get addressDong() {
        return this._addressDong;
    }
    get addressLi() {
        return this._addressLi;
    }
    get addressJibun() {
        return this._addressJibun;
    }
    get addressRoad() {
        return this._addressRoad;
    }
    get addressBuildingNumber() {
        return this._addressBuildingNumber;
    }
    get addressBuildingName() {
        return this._addressBuildingName;
    }
    get addressDetail() {
        return this._addressDetail;
    }
    get formattedFullAddress() {
        const addressData = new AddressFormVM({
            siDo: this._addressSiDo,
            siGunGu: this._addressSiGunGu,
            dong: this._addressDong,
            li: this._addressLi,
            jibun: this._addressJibun,
            road: this._addressRoad,
            buildingNumber: this._addressBuildingNumber,
            buildingName: this._addressBuildingName,
            detail: this._addressDetail,
        });
        return validateTextWithHypen(addressData.formattedAddressBasedOfLi('full'));
    }
    get formattedShortenAddress() {
        const addressData = new AddressFormVM({
            dong: this._addressDong,
            li: this._addressLi,
            jibun: this._addressJibun,
            road: this._addressRoad,
            buildingNumber: this._addressBuildingNumber,
            buildingName: this._addressBuildingName,
            detail: this._addressDetail,
        });
        return validateTextWithHypen(addressData.formattedAddressBasedOfLi());
    }
    get validatedStoreCode() {
        return validateTextWithHypen(this.code);
    }
    // 대행료 부가세
    get vatRate() {
        return this._vatRate;
    }
    get formattedVatRate() {
        return formatPercent(this._vatRate);
    }
    get deliveryPayFlag() {
        return this._deliveryPayFlag;
    }
    get formattedDeliveryPayFlag() {
        const [option,] = deliveryPayFlagOptionList
            .filter((flag) => flag.value === this.deliveryPayFlag);
        return option.text;
    }
    get deliveryFeeMonthly() {
        return this._deliveryFeeMonthly;
    }
    get deliveryFeeMonthlyDay() {
        return this._deliveryFeeMonthlyDay;
    }
    get endDeliveryCount() {
        return this._endDeliveryCount;
    }
    // 배달대행관리비_건당_정액 (원)
    get deliveryManagementFeePerOrder() {
        return this._deliveryManagementFeePerOrder;
    }
    // 배달대행관리비_건당_정률 (%)
    get deliveryManagementFeeRatePerOrder() {
        return this._deliveryManagementFeeRatePerOrder;
    }
    // 기획문서: https://www.notion.so/barogohq/deliveryFeeMonthlyDay-f6fe2f3d2d37432bb44893681954d8c1
    // api res case
    // ∙ 월정액 - 1, 5, 10, 15,20,25,35, 0 (0 = 사용안함, 35=매월말)
    // ∙ 건당 - 1, 5, 10, 15,20,25,35, 0, 99 (0 = 사용안함, 35=매월말, 99 =매일)
    // ∙ 월충전 - 날짜(YYYY-MM-DD), 0
    get formattedDeliveryFeeMonthlyDay() {
        let deliveryFeeMonthlyDayType = '';
        const { deliveryPayFlag, deliveryFeeMonthlyDay, } = this;
        if (deliveryFeeMonthlyDay < 35) {
            deliveryFeeMonthlyDayType = 'monthly_day';
        }
        if (deliveryFeeMonthlyDay === 0) {
            deliveryFeeMonthlyDayType = 'not_use';
        }
        const [, , , MONTHLY_CHARGE,] = deliveryPayFlagOptionList;
        if (deliveryFeeMonthlyDay > 0 && deliveryPayFlag === MONTHLY_CHARGE.value) {
            // 월충전의 경우, 사용안함이 아니라면 20230706 형태의 number data type이 api response에 담겨 옴
            // 문의 슬랙 스레드: https://barogo.slack.com/archives/C04UP4VFCKA/p1688617931037549
            const strDeliveryFeeMonthlyDay = String(deliveryFeeMonthlyDay);
            return `${strDeliveryFeeMonthlyDay.slice(0, 4)}-${strDeliveryFeeMonthlyDay.slice(4, 6)}-${strDeliveryFeeMonthlyDay.slice(6, 8)}`;
        }
        if (deliveryFeeMonthlyDay === 35) {
            deliveryFeeMonthlyDayType = 'the_end_of_each_month';
        }
        if (deliveryFeeMonthlyDay === 99) {
            deliveryFeeMonthlyDayType = 'everyday';
        }
        const lc = 'views.store_management.';
        if (deliveryFeeMonthlyDayType === 'monthly_day') {
            return i18n.t(`${lc}delivery_fee_monthly_day_type.${deliveryFeeMonthlyDayType}`, {
                day: deliveryFeeMonthlyDay,
            });
        }
        return i18n.t(`${lc}delivery_fee_monthly_day_type.${deliveryFeeMonthlyDayType}`);
    }
    // 관리비 상세
    // 피그마 : https://www.figma.com/file/rcrKiy08QJxWLoaJD42eQF/%5B%EC%83%81%EC%A0%90%5D-%EA%B4%80%EB%A6%AC-%E2%9B%88?type=design&node-id=4836-173673&mode=dev
    get validatedDeliveryDetail() {
        const [, , PER_CASE, MONTHLY_CHARGE,] = deliveryPayFlagOptionList;
        const { formattedDeliveryFeeMonthlyDay, deliveryFeeMonthlyDay, deliveryFeeMonthly, deliveryPayFlag, endDeliveryCount, deliveryManagementFeePerOrder, deliveryManagementFeeRatePerOrder, } = this;
        const deliveryDetailList = [
            formattedDeliveryFeeMonthlyDay,
        ];
        // '사용 안 함'일 경우
        if (deliveryFeeMonthlyDay === 0) {
            return deliveryDetailList;
        }
        // 월정액
        // 예: 매월 1일{deliveryFeeMonthlyDay} | 9,999{deliveryFeeMonthly} 원
        deliveryDetailList.push(currency(deliveryFeeMonthly));
        // 월충전
        // 예: 2023-07-06{deliveryFeeMonthlyDay} | 9,999{deliveryFeeMonthly} 원 | 9,999{endDeliveryCount} 건
        if (deliveryPayFlag === MONTHLY_CHARGE.value) {
            deliveryDetailList.push(`${numberToFormatted(endDeliveryCount)} ${i18n.t('unit.count')}`);
        }
        // 건당
        // 예: 매일{deliveryFeeMonthlyDay} | 9,999{deliveryFeeMonthly} 원 | 9,999{deliveryManagementFeePerOrder} 원 + 10{deliveryManagementFeeRatePerOrder} %
        if (deliveryPayFlag === PER_CASE.value) {
            deliveryDetailList.push(`${currency(deliveryManagementFeePerOrder)} + ${formatPercent(deliveryManagementFeeRatePerOrder)}`);
        }
        return deliveryDetailList;
    }
    get formattedDeliveryManagementFee() {
        return `${currency(this.deliveryManagementFeePerOrder)} + ${formatPercent(this.deliveryManagementFeeRatePerOrder)}`;
    }
    get depositBaromoney() {
        return this._depositBaromoney;
    }
    get formattedDepositBaromoney() {
        return currency(this._depositBaromoney);
    }
    get formattedBaromoney() {
        return currency(this._baromoney);
    }
    get formattedCreatedAt() {
        return formatDate(this._createdAt, dateFormatType.DATE);
    }
    get validatedHubCode() {
        return validateTextWithHypen(this._hubDTO.code);
    }
    get validatedMasterId() {
        return validateTextWithHypen(this._masterId);
    }
    get addressMemo() {
        return this._addressMemo;
    }
    get validateAddressMemo() {
        return validateTextWithHypen(this._addressMemo);
    }
    get memo() {
        return this._memo;
    }
    get validatedMemo() {
        return validateTextWithHypen(this._memo);
    }
    get phone() {
        return this._phone;
    }
    get formattedSafePhone() {
        return validateTextWithHypen(formatPhoneNumber(this._safePhone));
    }
    get fax() {
        return this._fax;
    }
    get formattedFax() {
        return validateTextWithHypen(formatPhoneNumber(this._fax));
    }
    get validatedMainVanTypeCode() {
        return validateTextWithHypen(this._mainVanTypeCode);
    }
    get vanCodeName() {
        return vanCodeEnum[this.validatedMainVanTypeCode] || this.validatedMainVanTypeCode;
    }
    get validatedMainVanTerminalId() {
        return validateTextWithHypen(this._mainVanTerminalId);
    }
    get formattedWithdrawalBankAccount() {
        return formatBankAccount(this._withdrawalBankAccount);
    }
    get formattedVirtualBankAccount() {
        return formatBankAccount(this._virtualBankAccount);
    }
    get businessName() {
        return this._businessName;
    }
    get validatedBusinessName() {
        return validateTextWithHypen(this._businessName);
    }
    get validatedBusinessNumber() {
        return validateTextWithHypen(formatBusinessNumber(this._businessNumber));
    }
    get ceoEmail() {
        return this._ceoEmail;
    }
    get validatedCeoEmail() {
        return validateTextWithHypen(this._ceoEmail);
    }
    get businessCondition() {
        return this._businessCondition;
    }
    get validatedBusinessCondition() {
        return validateTextWithHypen(this._businessCondition);
    }
    get businessType() {
        return this._businessType;
    }
    get validatedBusinessType() {
        return validateTextWithHypen(this._businessType);
    }
    get formattedDeliveryFeePerOrder() {
        return currency(this._deliveryFeePerOrder);
    }
    get formattedDeliveryFeeRatePerOrder() {
        return percentSignSuffix(this._deliveryFeeRatePerOrder);
    }
    get hubDeliveryPrePaymentFee() {
        return this._hubDeliveryPrePaymentFee;
    }
    get hubDeliveryPrePaymentFeeRate() {
        return this._hubDeliveryPrePaymentFeeRate;
    }
    get formattedHubDeliveryPrePaymentFee() {
        return currency(this._hubDeliveryPrePaymentFee);
    }
    get formattedHubDeliveryPrePaymentFeeRate() {
        return validateTextWithHypen(percentSignSuffix(this._hubDeliveryPrePaymentFeeRate));
    }
    get distanceProduct() {
        return this._distanceProduct;
    }
    get formattedDistanceProduct() {
        return distanceProductCodeObj[this.distanceProduct].text;
    }
    get deliveryPayType() {
        return this._deliveryPayType;
    }
    get goodsPayType() {
        return this._goodsPayType;
    }
    get formattedGoodsPayTypeObj() {
        return goodsPayTypeCode[this.goodsPayType];
    }
    get goodsPayRestrictType() {
        return this._options.goodsPayRestrictType;
    }
    get formattedGoodsPayRestictType() {
        return goodsPayRestrictTypeCode[this.goodsPayRestrictType].value;
    }
    get isSendBaromoneyRequired() {
        return this._options.isSendBaromoneyRequired;
    }
    get isCashReceiptsRequired() {
        return this._options.isCashReceiptsRequired;
    }
    get cookingTime() {
        return this._cookingTime;
    }
    // 상점의 본사 계약 여부
    get adjustmentType() {
        return this._options.adjustmentType;
    }
    /** 본사 계약 설정 */
    get formattedAdjustmentType() {
        return adjustmentTypeCode[this.adjustmentType]?.text;
    }
    get isInsufficientBaromoneyUnAccept() {
        return this._options.isInsufficientBaromoneyUnAccept;
    }
    get isDeliveryChargeNonSettingUnAccept() {
        return this._options.isDeliveryChargeNonSettingUnAccept;
    }
    // 기본할증
    get configSurchargeType() {
        return this._options.configSurchargeType;
    }
    get addChargeUseYn() {
        return this._addChargeUseYn;
    }
    get formattedAddCookingTime() {
        const lc = 'views.store_management_detail.';
        if (this._addCookingTime === 0) {
            return i18n.t(`${lc}bulletin_good`);
        }
        // 슬랙 문의 내역: https://barogo.slack.com/archives/C02GJBMBU6B/p1689229288511179
        if (this._deliveryWorkYn === 'D'
            || this._deliveryWorkYn === 'N') {
            return i18n.t(`${lc}bulletin_stop`);
        }
        return i18n.t('views.store_management_detail.delay_time', {
            time: this._addCookingTime,
        });
    }
    get dayDeliveryCount() {
        return this._dayDeliveryCount;
    }
    get formattedDayDeliveryCount() {
        return i18n.t('views.store_management_detail.day_delivery_count', {
            count: numberToFormatted(this.dayDeliveryCount),
        });
    }
    get deliveryCancelTime() {
        return this._deliveryCancelTime;
    }
    get orderLimitBaromoney() {
        return this._orderLimitBaromoney;
    }
    get formattedOrderLimitBaromoney() {
        return i18n.t('views.store_management_detail.order_limit_balance', {
            balance: currency(this._orderLimitBaromoney),
        });
    }
    get formattedAddDeliveryCharge() {
        const chargeFeeRate = this._addDeliveryChargeRate;
        const chargeFee = this._addDeliveryCharge;
        const chargeReason = surchargeType[this._options.irregularSurchargeType];
        if (chargeFeeRate || chargeFee || chargeReason.value !== 'NONE') {
            return `${percentSignSuffix(chargeFeeRate)} + ${currency(chargeFee)} / ${chargeReason.text}`;
        }
        return '-';
    }
    get formattedMaintenanceCostPerOrder() {
        if (this._deliveryFeePerOrder === 0 && this._deliveryFeeRatePerOrder === 0) {
            return '-';
        }
        return `${currency(this.formattedDeliveryFeePerOrder)}, ${percentSignSuffix(this.formattedDeliveryFeeRatePerOrder)}`;
    }
    get isMonthlyChargeUnAccept() {
        return this._options.isMonthlyChargeUnAccept;
    }
    get formattedIsMonthlyChargeUnAccept() {
        return isMonthlyChargeUnAcceptOptionList.find((data) => data.value === this.isMonthlyChargeUnAccept)?.text;
    }
    get workerFeePerStoreGroupId() {
        return this._workerFeePerStoreGroupDTO.id;
    }
    get validatedWorkerFeePerStoreGroupName() {
        if (this._workerFeePerStoreGroupDTO && this._workerFeePerStoreGroupDTO.name) {
            return this._workerFeePerStoreGroupDTO.name;
        }
        return '-';
    }
    get validatedFilteredDeliveryPayFlagList() {
        const list = Object.values(deliveryPayFlagDetailList);
        const filtered = list.filter((data) => data.isShow.includes(this.deliveryPayFlag));
        return filtered;
    }
    // 관리비 부가세
    get vatRateMonthly() {
        return this._vatRateMonthly;
    }
    get formattedVatRateMonthly() {
        return validateTextWithHypen(percentSignSuffix(this.vatRateMonthly));
    }
    get formattedEndDeliveryCount() {
        const lc = 'views.store_management_detail.';
        const count = numberToFormatted(this.endDeliveryCount);
        return i18n.t(`${lc}end_delivery_count`, {
            count,
        });
    }
    get formattedDeliveryFeeMonthly() {
        return validateTextWithHypen(currency(this._deliveryFeeMonthly));
    }
    get ceoResidentRegistrationNumber() {
        return this._ceoResidentRegistrationNumber;
    }
    get goodsPriceSurchargeInfoDTOListCount() {
        const { length } = this._goodsPriceSurchargeInfoDTOList;
        return length;
    }
    get formattedGoodsPriceSurchargeInfoDTOListCount() {
        const lc = 'views.store_management_detail.';
        const { length } = this._goodsPriceSurchargeInfoDTOList;
        if (length) {
            return i18n.t(`${lc}count_of_goods_price_surcharge`, {
                count: length,
            });
        }
        return '-';
    }
}
